import { Group, Text } from "@mantine/core";
import IconGripVertical from "@tabler/icons-react/dist/esm/icons/IconGripVertical.mjs";
import { useDraggable } from "@dnd-kit/core";

import { DRAG_ENTITY_FIELD } from "../../dnd/kinds";
import classes from "./EntityField.module.scss";

/**
 * A single draggable row inside the entity accordion (an entity's field).
 * Emits a DRAG_ENTITY_FIELD draggable that the central handleDragEnd
 * recognizes when dropped on condition / data-field / group-by / order-by
 * targets.
 */
export default function EntityField({
  queryId,
  entityField,
  displayedEntityId,
  canEdit = true,
}) {
  const draggableId = `entity-field::${displayedEntityId}::${entityField.id}`;

  const { attributes, listeners, setNodeRef, isDragging } =
    useDraggable({
      id: draggableId,
      data: {
        kind: DRAG_ENTITY_FIELD,
        entityField,
        displayedEntityId,
        queryId,
      },
      disabled: !canEdit,
    });

  // No `transform` here — the QueryBuilder DragOverlay renders the
  // drag visual. We just dim the source row so the user sees which
  // row is the origin of the drag.
  const style = {
    opacity: isDragging ? 0.4 : 1,
  };

  return (
    <div
      ref={canEdit ? setNodeRef : undefined}
      style={style}
      {...(canEdit ? attributes : {})}
      {...(canEdit ? listeners : {})}
      className={`${classes.item} ${canEdit ? classes.grabbable : ""}`}
    >
      <Group gap={6} wrap="nowrap">
        {canEdit && (
          <IconGripVertical
            size={14}
            stroke={1.5}
            className={classes.gripIcon}
          />
        )}
        <Text size="sm">{entityField.name}</Text>
      </Group>
    </div>
  );
}
